// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4d8509e0","453":"9741a2e2","455":"b7026571","977":"5d7e879e"}[chunkId] + ".chunk.js";
};